module.exports = __webpack_public_path__ + "static/media/image-10-full.106af18b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-10-full.jpg
// module id = 344
// module chunks = 0